// src/components/studio/StudioFooter.tsx
import { ChevronRight } from "lucide-react";
import { ArchetypeId } from "../../constants/archetypes";
import { StepId, StepValidation } from "../../types/studio.types";

interface StudioFooterProps {
  activeStep: StepId;
  validation: StepValidation;
  showSavedCardFooter: boolean;
  showEditingFooter: boolean;
  isSaving: boolean;
  hasUnsavedChanges: boolean;
  archetype: ArchetypeId;
  onNext: () => void;
  onPreview: () => void;
  onPayment: () => void;
}

const ARCHETYPE_BUTTON_THEMES: Record<
  ArchetypeId,
  {
    background: string;
    color: string;
    shadow: string;
    border: string;
  }
> = {
  heartbeat: {
    background: "linear-gradient(135deg, #ff4d6d 0%, #ff8fa3 100%)",
    color: "#ffffff",
    shadow: "0 18px 45px rgba(255, 77, 109, 0.28)",
    border: "1px solid rgba(255, 255, 255, 0.16)",
  },
  moments: {
    background: "linear-gradient(135deg, #f9ca24 0%, #f0932b 100%)",
    color: "#120b04",
    shadow: "0 18px 45px rgba(249, 202, 36, 0.24)",
    border: "1px solid rgba(255, 255, 255, 0.18)",
  },
  safehaven: {
    background: "linear-gradient(135deg, #a5b1c2 0%, #4b6584 100%)",
    color: "#ffffff",
    shadow: "0 18px 45px rgba(165, 177, 194, 0.22)",
    border: "1px solid rgba(255, 255, 255, 0.16)",
  },
};

export default function StudioFooter({
  activeStep,
  validation,
  showSavedCardFooter,
  showEditingFooter,
  isSaving,
  hasUnsavedChanges,
  archetype,
  onNext,
  onPreview,
  onPayment,
}: StudioFooterProps) {
  const isValid = validation[`isStep${activeStep}Valid` as keyof typeof validation];
  const theme = ARCHETYPE_BUTTON_THEMES[archetype];

  const isContinueState = !isSaving && activeStep !== 3;

  const primaryButtonStyle = isContinueState
    ? {
        // background: theme.background,
        color: "white",
        // boxShadow: theme.shadow,
        // border: theme.border,
      }
    : undefined;

  if (showSavedCardFooter) {
    return (
      <footer className="mt-3">
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onPreview}
            className="
              flex-1
              rounded-2xl
              border
              border-white/20
              bg-white/10
              py-4
              text-xs
              font-black
              uppercase
              tracking-[0.2em]
              transition-all
              hover:bg-white/20
            "
          >
            Preview
          </button>

          <button
            type="button"
            onClick={onPayment}
            style={{
              background: theme.background,
              color: theme.color,
              boxShadow: theme.shadow,
              border: theme.border,
            }}
            className="
              flex-1
              rounded-2xl
              py-4
              text-xs
              font-black
              uppercase
              tracking-[0.2em]
              transition-all
              active:scale-95
            "
          >
            Share Now
          </button>
        </div>
      </footer>
    );
  }

  if (showEditingFooter) {
    return (
      <footer className="mt-3">
        <button
          type="button"
          onClick={onNext}
          disabled={isSaving || (activeStep < 4 && !isValid)}
          style={primaryButtonStyle}
          className={`
         w-full
  rounded-2xl
  py-3.5
  md:py-4
  text-xs
  font-black
  uppercase
  tracking-[0.18em]
  flex
  items-center
  justify-center
  gap-2
  active:scale-95
  transition-all
  disabled:opacity-50
  disabled:cursor-not-allowed

         
          `}
        >
          {isSaving
            ? "Saving..."
            : activeStep === 3
              ? hasUnsavedChanges
                ? "Save Changes"
                : "Finalize Surprise"
              : "Continue"}

          {!isSaving && <ChevronRight size={16} />}
        </button>
      </footer>
    );
  }

  return null;
}
